<template>
  <section
    v-if="shouldRender"
    id="links-panel"
    class="panel panel-default"
    role="region"
    aria-labelledby="links-heading"
    :aria-busy="!linksReady"
  >
    <div class="panel-body">
      <div class="panel-header">
        <h2 id="links-heading">Links</h2>
      </div>
      <learner-links-list
        v-if="showContent"
        :links="links"
        :can-manage="false"
      />
    </div>
  </section>
</template>

<script>
import LearnerLinksList from '@base-components/learner-links/learner-links-list.vue';

export default {
  name: 'LearnerHomepageLinksPanel',

  components: {
    LearnerLinksList,
  },

  props: {
    programmeId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      links: [],
      linksReady: false,
    };
  },

  computed: {
    shouldRender() {
      if (!this.programmeId) {
        return false;
      }
      if (!this.linksReady) {
        return true;
      }
      return this.links.length > 0;
    },

    showContent() {
      return this.linksReady && this.links.length > 0;
    },
  },

  watch: {
    programmeId: {
      immediate: true,
      handler() {
        this.fetchLinks();
      },
    },
  },

  methods: {
    fetchLinks() {
      if (!this.programmeId) {
        this.links = [];
        this.linksReady = true;
        return;
      }

      this.linksReady = false;
      this.$http
        .get(`/api/profile/user/programmes/${this.programmeId}/links`)
        .then(result => {
          this.links = result.data;
        })
        .catch(error => {
          this.links = [];
          this.$logger.autowarn(
            'Error getting learner homepage links',
            { programmeId: this.programmeId },
            error,
          );
          this.$ktoast.showError(error);
        })
        .then(() => {
          this.linksReady = true;
        });
    },
  },
};
</script>
